import React, { useEffect } from "react";
import useGoToPricing from "../../hooks/useGoToPricing";
import { isLoggedIn } from "../../utils/isLoggedIn";
import Header from "../Homepage/sections/Header";
import Footer from "../Homepage/sections/Footer";
import { Page, HomepageGlobalStyles } from "../Homepage/styles";
import {
  LegalArticle,
  LegalBackButton,
  LegalBackWrap,
  LegalHeader,
  LegalInner,
  LegalMain,
  LegalTitle,
  LegalUpdated,
} from "./LegalDoc.styles";

const ArrowUpIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M12 19V5" />
    <path d="M5 12l7-7 7 7" />
  </svg>
);

/**
 * Lovable legal-page shell. Pass structured React body as children (prod copy).
 */
const LegalDocPage = ({ title, lastUpdated, children }) => {
  const goToPricing = useGoToPricing();
  const loggedIn = isLoggedIn();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Page>
      <HomepageGlobalStyles />
      <Header onSubscribeClick={goToPricing} hideSpacer />

      <LegalMain>
        <LegalInner>
          <LegalHeader>
            <LegalTitle>{title}</LegalTitle>
            <LegalUpdated>Last updated: {lastUpdated}</LegalUpdated>
          </LegalHeader>

          <LegalArticle>{children}</LegalArticle>

          <LegalBackWrap>
            <LegalBackButton type="button" onClick={scrollToTop}>
              <ArrowUpIcon />
              Back to top
            </LegalBackButton>
          </LegalBackWrap>
        </LegalInner>
      </LegalMain>

      <Footer onSubscribeClick={goToPricing} hideSubscribeCta={loggedIn} />
    </Page>
  );
};

export default LegalDocPage;
